export const DETAILS_PAGE_TEST_ID = 'DetailsPage';
export const LOADING_STATE_TEST_ID = 'LoadingState';
export const ACCORDION_DETAILS_PANEL = 'AccordionDetailsPanel';
